// extracted by mini-css-extract-plugin
module.exports = {"main":"BrandInformationModalItem_main__ZmPk8","icon":"BrandInformationModalItem_icon__gv8bK","text":"BrandInformationModalItem_text__Su_z4"};